import axios from "./axiosConfig";
import { API_URL } from "../config";

export interface Report {
  id: number;
  name: string;
  slug: string;
}

export const ReportService = {
  getAllReports: async (): Promise<Report[]> => {
    try {
      const response = await axios.get(`${API_URL}/v1/reports`);
      if (response.status === 204) {
        return [];
      }
      const data = response.data;
      if (Array.isArray(data)) {
        return data;
      }
      return Array.isArray(data?.items) ? data.items : [];
    } catch (error) {
      console.error("Error fetching reports:", error);
      throw error;
    }
  },
  getReport: async (reportId: number, campaignId: number): Promise<void> => {
    try {
      const response = await axios.get(`${API_URL}/v1/report/${reportId}/campaign/${campaignId}`, {
        responseType: "blob",
      });
      let filename = "report.xlsx";
      const disposition = response.headers["content-disposition"];
      console.log(disposition)
      if (disposition) {
        const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match && match[1]) {
          filename = match[1].replace(/['"]/g, "");
        }
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Erro ao baixar o relatório:", error);
      throw error;
    }
  },
};
